import { ProjetosProvider } from "src/providers/ProjetosProvider"
import { Fileira } from "../../types";

const projetosProvider = new ProjetosProvider();

interface CalcularEstruturasInput {
  moduloId: number;
  fileiras: Fileira[],
  potencia: number
  regioes: number[]
  inversor: string
}

export const calcularEstruturas = async (data: CalcularEstruturasInput) => {
  const { moduloId, fileiras, inversor, potencia, regioes } = data;

  const estruturaResult = await projetosProvider.calcularEstrutura(moduloId, {
    inversor,
    potencia,
    regiao_id: regioes.map(String),
    fileiras: fileiras.map(item => {
      return {
        estrutura_id: Number(item?.tipo_estrutura?.value) || 0,
        estruturas_grupo_id: Number(item?.tipo_estrutura?.estruturas_grupo_id) || 0,
        fileiras_iguais: item.fileiras,
        modulos_sequencia: item.quantidade_modulos,
        posicao: item.posicao_modulo?.value || 'retrato',
      }
    }),
    segmento: 'on',
  })

  return estruturaResult.data.map(item => ({
      altura: item.altura,
      categoria_componentes_id: item.categoria_componentes_id,
      componente_id: item.id,
      descricao: item.descricao,
      largura: item.largura,
      nome: item.nome,
      peso: item.peso,
      potencia: 0,
      quantidade: item.quantidade || 0,
      quantidade_original: item.quantidade || 0,
      valor: 0,
      estruturas_grupo_id: item.estruturas_grupo_id,
      valor_unitario: 0,
      exibir_popup_parceiro: item.exibir_popup_parceiro,
    }))
}